import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './Banner.module.scss'

const MOCK = [
  { quantity: '2.5M+', description: 'User reviews' },
  { quantity: '45,000+', description: 'Software solutions' },
  { quantity: '1,000+', description: 'Software types' },
]

const Banner = () => (
  <div className={clsx('Banner', classes.root)}>
    <div className={classes.container}>
      {MOCK.map(item => (
        <div className={classes.item} key={`banner-item-${item.description}`}>
          <p className={classes.itemQuantity}>{item.quantity}</p>
          <p className={classes.itemDescription}>{item.description}</p>
        </div>
      ))}
    </div>
    <Icon icon="getapp-logo" prefix="ga" className={classes.logo} />
  </div>
)

export default Banner
